module.exports = __webpack_public_path__ + "static/media/jacAlvarez.70950ddd.png";